module.exports = __webpack_public_path__ + "img/prescription_info.dddf4cff.svg";